export type PurchaseEntry = "seatmap-all" | "ticket-select";

/**
 * Decide por dónde entra la compra según la forma del evento
 * (localidades-mixtas RF-2/RF-3).
 * - 100% numerado (numbered && !hasGeneralLocality) → mapa con todas las localidades.
 * - general o mixto → selector de cantidad (las numeradas ofrecen "Elegir asiento").
 */
export function resolvePurchaseEntry(
  isNumberedEvent: boolean,
  hasGeneralLocality: boolean,
): PurchaseEntry {
  if (isNumberedEvent && !hasGeneralLocality) return "seatmap-all";
  return "ticket-select";
}
